import { defineStore } from 'pinia';
import mxDepotApi from '@api/mxdepot';

export const useMxDepotStore = defineStore('mxdepot', {
    state: () => {
        return {
            loading: false,
            data: {},
            createValues: {
                radius: 30, // has to be a multiple of 10
                type: 'LOCAL',
                active: true,
                routes: [
                    { min_cubes: 0, max_cubes: 10, price_per_cube: null, min_price: null },
                    { min_cubes: 11, max_cubes: 35, price_per_cube: null, min_price: null },
                ],
            },
        };
    },
    getters: {},
    actions: {
        async create(data) {
            try {
                this.loading = true;
                await mxDepotApi.create(data);
                this.loading = false;
            } catch (error) {
                this.loading = false;
                throw error;
            }
        },

        async retrieve(mxDepotId) {
            try {
                this.loading = true;
                const mxDepot = await mxDepotApi.retrieve(mxDepotId);
                this.mapResponseValues(mxDepot.data);
                this.loading = false;
            } catch (error) {
                this.loading = false;
                // let the form component display the error
                throw error;
            }
        },

        async update(mxDepotId, payload) {
            try {
                this.loading = true;
                const data = await mxDepotApi.update(mxDepotId, payload);
                this.mapResponseValues(data.data.muvexpress_depot);
                this.loading = false;
            } catch (error) {
                this.loading = false;
                throw error;
            }
        },

        mapResponseValues(mxDepot) {
            this.data.id = mxDepot.id;
            this.data.label = mxDepot.label;
            this.data.location = mxDepot.label;
            this.data.type = mxDepot.type;
            this.data.radius = mxDepot.radius;
            this.data.start_point = mxDepot.start_point;
            if (mxDepot.type == 'LOCAL') {
                this.data.rates = { small: {}, large: {} };

                let smallIndex = mxDepot.rates.findIndex((item) => item.truck_size == 'SMALL');
                let largeIndex = mxDepot.rates.findIndex((item) => item.truck_size == 'LARGE');

                // Small
                if (smallIndex != -1) {
                    this.data.rates.small.two_mon_fri = mxDepot.rates[smallIndex].two_mon_fri?.amount;
                    this.data.rates.small.three_mon_fri = mxDepot.rates[smallIndex].three_mon_fri?.amount;
                    this.data.rates.small.four_mon_fri = mxDepot.rates[smallIndex].four_mon_fri?.amount;

                    this.data.rates.small.two_sat = mxDepot.rates[smallIndex].two_sat?.amount;
                    this.data.rates.small.two_sun = mxDepot.rates[smallIndex].two_sun?.amount;
                    this.data.rates.small.three_sat = mxDepot.rates[smallIndex].three_sat?.amount;
                    this.data.rates.small.three_sun = mxDepot.rates[smallIndex].three_sun?.amount;
                    this.data.rates.small.four_sat = mxDepot.rates[smallIndex].four_sat?.amount;
                    this.data.rates.small.four_sun = mxDepot.rates[smallIndex].four_sun?.amount;
                } else {
                    this.data.rates.small = null;
                }

                // Large
                if (largeIndex != -1) {
                    this.data.rates.large.two_mon_fri = mxDepot.rates[largeIndex].two_mon_fri?.amount;
                    this.data.rates.large.three_mon_fri = mxDepot.rates[largeIndex].three_mon_fri?.amount;
                    this.data.rates.large.four_mon_fri = mxDepot.rates[largeIndex].four_mon_fri?.amount;

                    this.data.rates.large.two_sat = mxDepot.rates[largeIndex].two_sat?.amount;
                    this.data.rates.large.two_sun = mxDepot.rates[largeIndex].two_sun?.amount;
                    this.data.rates.large.three_sat = mxDepot.rates[largeIndex].three_sat?.amount;
                    this.data.rates.large.three_sun = mxDepot.rates[largeIndex].three_sun?.amount;
                    this.data.rates.large.four_sat = mxDepot.rates[largeIndex].four_sat?.amount;
                    this.data.rates.large.four_sun = mxDepot.rates[largeIndex].four_sun?.amount;
                } else {
                    this.data.rates.large = null;
                }
            } else if (mxDepot.type == 'INTERSTATE') {
                this.data.route_delivery_timeframe = mxDepot.route_delivery_timeframe;
                this.data.route = mxDepot.route;
                this.data.routes = [];
                if (Object.keys(mxDepot.routeRates).length > 0) {
                    mxDepot.routeRates.forEach((route) => {
                        this.data.routes.push({
                            id: route.id,
                            price_per_cube: route.price_per_cube?.amount,
                            min_price: route.min_price?.amount,
                            min_cubes: route.min_cubes,
                            max_cubes: route.max_cubes,
                        });
                    });
                }
            }
        },
    },
});
